import { render } from "./Afiliaciones.vue?vue&type=template&id=8fc068ae&scoped=true"
import script from "./Afiliaciones.vue?vue&type=script&lang=js"
export * from "./Afiliaciones.vue?vue&type=script&lang=js"

import "./Afiliaciones.vue?vue&type=style&index=0&id=8fc068ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc068ae"]])

export default __exports__